import React from "react";

function EthereumWalletHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Ethereum Wallet Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Unlock the full potential of the Ethereum ecosystem with our
                    customized Ethereum wallet development services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EthereumWalletHero;
